module.exports = __webpack_public_path__ + "static/media/ice18.5af4da13.webp";